
import state from './../../../../../zviz2/zviz/state';
import {Controller as GroupController} from './../../../../../zviz2/zviz/components/group';

import {extend, cloneObject} from './../../../../../zviz2/zviz/functions';

import Countries from './countries';

class Controller extends GroupController{

    

} 


let Blueprint = {
    type: Controller,
    properties: {
        data: {
            height: 500,
            autoHeight: false,
            width: 500,
            fadeOut: false,
            selected: [],
            highlight: false,
            maxScale: 1000,
            title: false,
            colors: {
                normal: [180,180,180],
                highlight: [255,0,0]
            }
        },
        attributes: {
            'transform': 'translate(0,0)',
            // 'clip-path': 'url(#mapClipPath)'
        },
        style: {
            // 'clip-path': 'url(#mapClipPath)'
        }
    },
    children: [
        
        (parent) => ( extend({
            properties: {
                data: {
                    selected: parent.data.selected,
                    highlight: parent.data.highlight,
                    width: parent.data.width,
                    height: parent.data.height,
                    autoHeight: parent.data.autoHeight,
                    maxScale: parent.data.maxScale,
                    title: parent.data.title,
                    colors: parent.data.colors
                }
            },
            responders: [
                {name: 'height', callback: [parent, function(height){ this.trigger('height', height); }] }
            ],
        }, Countries) ),
            
    ]
}


export default Blueprint;

